module.exports = {
      id: "ic-horizontal-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-horizontal-usage",
      toString: function () {
        return this.url;
      }
    }